import { api } from './api'
import type {
  GateableRole,
  FeatureKey,
  MemberFeatureOverrideRow,
  RoleFeatureAccessRow,
} from '@riverpark/types'

export async function listRoleFeatureAccess(): Promise<{ data: RoleFeatureAccessRow[] }> {
  return api.get<{ data: RoleFeatureAccessRow[] }>('/access-control/roles')
}

export async function updateRoleFeatureAccess(body: {
  role: GateableRole
  featureKey: FeatureKey
  enabled: boolean
}): Promise<{ data: { success: true } }> {
  return api.patch<{ data: { success: true } }>('/access-control/roles', body)
}

export async function listMemberFeatureOverrides(): Promise<{
  data: MemberFeatureOverrideRow[]
}> {
  return api.get<{ data: MemberFeatureOverrideRow[] }>('/access-control/overrides')
}

export async function updateMemberFeatureOverride(body: {
  memberId: string
  featureKey: FeatureKey
  enabled: boolean | null
}): Promise<{ data: { success: true } }> {
  return api.patch<{ data: { success: true } }>('/access-control/overrides', body)
}
